import * as React from 'react';
import { ArticleHeading3, ArticleParagraph2, ArticleParagraph3, ModalWindow } from '@cian/ui-kit';

import { BankItem } from './components/BankItem';
import { AuthorItem } from './components/AuthorItem';
import { getBankLogoUrl } from './helpers';

import * as styles from './PromoDetailsModal.css';

import { IFeature, IPromoBank } from '../../types/newbuilding/promoInfo';

export interface IPromoDetailsModalProps {
  authorDescription?: string | null;
  authorName?: string | null;
  authorLabel?: string | null;
  authorLogoUrl?: string | null;
  contactsButton?: React.ReactNode;
  bank?: IPromoBank | null;
  banks?: IPromoBank[] | null;
  description?: string | null;
  features?: IFeature[] | null;
  mortgagePartnerLink: string | null;
  onClose(): void;
  onMortgageClick?(): void;
  open: boolean;
  subtitle?: string | null;
  title: string;
}

export const PromoDetailsModal: React.FC<IPromoDetailsModalProps> = ({
  authorDescription,
  authorLabel,
  authorLogoUrl,
  authorName,
  bank,
  banks,
  contactsButton,
  description,
  features,
  mortgagePartnerLink,
  onClose,
  onMortgageClick,
  open,
  subtitle,
  title,
}) => {
  return (
    <ModalWindow title={title} open={open} fixed={false} width="100%" maxWidth={688} onClose={onClose} escape outside>
      <div className={styles['content']} data-testid="PromoDetailsModal">
        {subtitle && (
          <div className={styles['subtitle']}>
            <div className={styles['text']}>{subtitle}</div>
          </div>
        )}
        {features && !!features.length && (
          <div className={styles['features-list']}>
            {features.map(({ name, value }, idx) => (
              <div key={idx} className={styles['feature']}>
                <ArticleParagraph3 color="text-secondary-default">{name}</ArticleParagraph3>
                <div className={styles['text']}>{value}</div>
              </div>
            ))}
          </div>
        )}
        {description && (
          <div className={styles['description']}>
            <div className={styles['text']}>{description}</div>
          </div>
        )}
        {banks && !!banks.length && (
          <div className={styles['banks']}>
            <div className={styles['banks-title']}>
              <ArticleHeading3>Банки</ArticleHeading3>
            </div>
            <ul className={styles['banks-list']}>
              {banks.map(bank => (
                <li key={bank.id} className={styles['bank-item']}>
                  <BankItem
                    logoUrl={getBankLogoUrl(bank)}
                    mortgagePartnerLink={mortgagePartnerLink}
                    name={bank.name}
                    onMortgageClick={onMortgageClick}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
        {bank && (
          <div className={styles['banks']}>
            <BankItem
              label="Банк"
              logoUrl={getBankLogoUrl(bank)}
              mortgagePartnerLink={mortgagePartnerLink}
              name={bank.name}
              onMortgageClick={onMortgageClick}
            />
          </div>
        )}
        {authorName && (
          <>
            <AuthorItem label={authorLabel} name={authorName} logoUrl={authorLogoUrl} contactsButton={contactsButton} />
            {authorDescription && (
              <div className={styles['author-description']}>
                <ArticleParagraph2 color="text-secondary-default">{authorDescription}</ArticleParagraph2>
              </div>
            )}
          </>
        )}
      </div>
    </ModalWindow>
  );
};
